import { render } from "./OphthalmologyPage.vue?vue&type=template&id=52ac678e"
import script from "./OphthalmologyPage.vue?vue&type=script&lang=js"
export * from "./OphthalmologyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__